import ImageViewer from "../ImageViewer/ImageViewer";
import ImageViewerObject from "./ImageViewerObject";
import {
    addToCanvas,
    applyOffset,
    createCanvasObjectFromTagObject,
    ImageViewerCanvasObject,
    isGraph
} from "./ImageViewerCanvasObject";
import {ivObj} from "../../UtilitiesTs";

export class DuplicateObjectHandler {
    private readonly _iv: ImageViewer;

    constructor(iv: ImageViewer) {
        this._iv = iv;
    }

    duplicate(sourceRaw: ImageViewerObject | ImageViewerCanvasObject | undefined): ImageViewerObject | undefined {
        if (sourceRaw === undefined) return;
        const iv = this._iv;

        const source = ivObj(sourceRaw);
        const tagObj = source.toTagObjectDeepCopy();

        iv.lastObjectIndex += 1;
        tagObj.id = iv.lastObjectIndex;

        const copy = createCanvasObjectFromTagObject(tagObj, iv);
        if (isGraph(copy)) {
            applyOffset(copy, { x: 64, y: 64});
        } else {
            applyOffset(copy, { x: 10, y: 10});
        }
        addToCanvas(copy, iv.canvas);

        iv.renderAll$.next(1);
        iv.objectsChanged$.next(1);
        iv.objectSelected$.next({target: copy, source: 'canvas'});

        return ivObj(copy);
    }

    registerEvents() {

    }
}